import { Tabs } from '@design-systems/canvas-ui'

/**
 * Wraps Canvas 8 Tabs with a div that provides page-level tab styling.
 * Canvas 8 Tabs renders internal Grid wrapper divs that we can't style,
 * so this wrapper takes over the layout role that C-Tabs played in Canvas 7.
 *
 * Applies the .mpm-page-tabs class for consistent page-level tab styling
 * (centered, bottom border, proper spacing from the layout header).
 */
export const PageTabs = ({
    className,
    children,
    ...tabsProps
}: React.ComponentProps<typeof Tabs>) => {
    return (
        <div className="mpm-page-tabs">
            <Tabs className={className} {...tabsProps}>
                {children}
            </Tabs>
        </div>
    )
}
